var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 46,
    viewBox: "0 0 41 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.39502 18.5417H39.5942L39.1777 40.5534L14.2658 45.9999L0.661971 36.8257L0.39502 18.5417Z",
    fill: "#AB5500"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2658 45.9999V18.5417H0.39502L0.661971 36.8257L14.2658 45.9999Z",
    fill: "url(#paint0_radial_1_18221)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2659 18.5417V45.9999L39.1778 40.5534L39.5942 18.5417H14.2659Z",
    fill: "url(#paint1_radial_1_18221)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.04319 37.986C1.4308 36.7828 0.875542 35.9341 0.640625 34.6021L0.672659 36.8258L14.2765 45.9893V43.454C13.9989 44.1523 13.0272 44.2275 12.237 43.873C9.74901 42.7772 5.2749 39.6511 3.04319 37.9752V37.986Z",
    fill: "url(#paint2_radial_1_18221)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2659 43.4648V46L39.1671 40.5535L39.2312 36.8688C38.8574 38.3405 38.1206 39.1784 36.0171 40.1453C31.9701 41.9823 23.4704 43.9374 19.0496 44.4101C16.8606 44.6464 14.5969 44.6035 14.2659 43.4648Z",
    fill: "url(#paint3_radial_1_18221)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.43786 21.2275L0.416504 19.4012L14.2766 27.1789V30.5091C13.337 27.3508 3.0967 20.4755 0.43786 21.2382V21.2275Z",
    fill: "url(#paint4_radial_1_18221)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2659 30.4984C16.6364 26.2443 34.2872 23.0967 39.4981 24.0528L39.5408 21.5713L14.2659 26.717V30.4984Z",
    fill: "url(#paint5_radial_1_18221)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0854245 19.2186L14.095 27.2111L39.8719 22.4521L40 15.3619L0 12.2573L0.0854245 19.2186Z",
    fill: "#AB5500"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12.2573L14.095 19.9061V27.2111L0.0854245 19.2186L0 12.2573Z",
    fill: "url(#paint6_radial_1_18221)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.095 19.9061L39.9999 15.3619L39.8718 22.4521L14.095 27.2111V19.9061Z",
    fill: "url(#paint7_radial_1_18221)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12.2574L14.095 19.9061L40 15.362L24.7944 8.26111L0 12.2574Z",
    fill: "url(#paint8_radial_1_18221)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0635 26.1368C16.1773 25.3096 16.3588 23.1181 17.1276 22.248C19.0497 20.0672 35.7501 15.9743 38.4837 17.1022C39.6903 17.5964 39.9253 19.9705 39.7971 21.1093C39.7224 21.786 39.4768 22.2157 39.1671 22.5703L39.8825 22.4413L40.0107 15.3512L14.1057 19.8953V27.2003L17.8644 26.5128C17.5761 26.4376 17.2985 26.3409 17.0849 26.1368H17.0635Z",
    fill: "url(#paint9_radial_1_18221)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.811532 19.1971C0.459156 18.2625 0.117459 15.8776 0.843566 15.0719C2.02883 13.7398 5.24293 15.4909 6.3748 16.0602C8.32888 17.0378 11.7993 19.1004 12.771 21.0556C13.0806 21.6894 13.3049 22.3662 13.4223 23.0644C13.5505 23.8164 13.4544 25.7501 12.5894 26.0616C12.4506 26.1153 12.3118 26.1153 12.1623 26.1153L14.095 27.2218V19.9168L0 12.2573L0.0854245 19.2186L1.16391 19.8309C1.01442 19.6375 0.896957 19.4334 0.811532 19.2078V19.1971Z",
    fill: "url(#paint10_radial_1_18221)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.86546 12.4937C4.19648 11.9243 5.20021 11.5269 6.15056 11.269L0 12.2574L14.095 19.9061L40 15.362L36.3481 13.6539C36.7112 14.4059 36.1666 15.0397 34.7678 15.4587C29.7811 16.9841 21.7939 18.2088 16.6578 18.4774C15.8142 18.5203 14.96 18.4774 14.1271 18.3592C11.0198 17.908 7.42125 16.1462 4.91191 14.2877C3.9402 13.568 3.56647 12.9879 3.86546 12.483V12.4937Z",
    fill: "url(#paint11_radial_1_18221)"
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.47778 15.233C6.96203 16.1139 13.2941 19.7557 13.6358 20.1424C13.9882 20.5292 13.9989 22.0976 14.0843 25.7931C14.2018 24.2354 14.3299 20.5829 14.5648 20.2391C14.9172 19.9598 35.7074 16.1462 38.6972 15.5875C34.2658 16.3073 14.8318 19.4764 14.1697 19.4979C13.134 19.3152 7.54933 16.2751 5.47778 15.233Z",
    fill: "#FF6A66"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1576 25.1593L24.6023 43.7333L29.7598 42.6053L30.3684 24.1924C30.3898 21.8076 30.4218 19.412 30.4432 17.0271L25.2003 17.9402C25.1896 20.3466 25.1682 22.7422 25.1576 25.1485V25.1593Z",
    fill: "url(#paint12_radial_1_18221)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.73845 42.9491L9.31133 24.4825L9.2793 17.2956L4.64502 14.7819C4.66638 17.1345 4.68773 19.4979 4.70909 21.8505L5.21096 39.8982L9.74913 42.9491H9.73845Z",
    fill: "url(#paint13_radial_1_18221)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4432 17.0378C27.6883 15.6627 24.5382 14.4703 21.7513 13.106C19.5943 12.0425 17.5228 10.8823 15.6541 9.73279L10.7849 10.517C13.4331 11.7631 15.9851 12.9448 18.4624 14.2232C20.8009 15.4264 22.8618 16.7585 25.2003 17.9617L30.4432 17.0485V17.0378Z",
    fill: "url(#paint14_radial_1_18221)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.65,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9365 16.7155C21.6231 14.9 25.0722 14.9967 26.6311 15.2867C24.976 14.567 23.3103 13.858 21.7513 13.0952C19.5943 12.0317 17.5228 10.8715 15.6541 9.72205L10.7849 10.5063C13.4331 11.7524 15.9851 12.9341 18.4624 14.2125C20.0214 15.0182 21.463 15.8776 22.9365 16.7155Z",
    fill: "url(#paint15_radial_1_18221)"
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.2793 17.2957C13.7427 16.533 17.6616 15.4694 22.125 14.7067C26.172 14.0192 30.8703 13.3531 34.7999 12.9342L29.8025 10.603C26.4389 11.1616 23.2462 11.9566 19.8719 12.5152C14.8532 13.3424 9.66371 13.944 4.64502 14.7712L9.2793 17.285V17.2957Z",
    fill: "url(#paint16_radial_1_18221)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.70898 21.8505V21.4423C5.21085 22.1405 8.36088 24.2139 9.31123 23.9453V24.4824L9.35394 26.5665C9.25784 26.1046 9.02292 25.3741 8.29681 24.6006C7.15426 23.3867 5.2856 22.248 4.74102 23.0966L4.70898 21.8505Z",
    fill: "#F39200"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1575 25.1593V24.4932C25.6701 25.4063 30.1121 24.4073 30.3791 23.4297V24.1924L30.315 26.1046C30.1976 25.6856 30.016 25.3204 29.5355 25.2452C28.5638 25.0948 26.9194 25.5138 25.9263 26.3517C25.3711 26.8244 25.1255 27.4904 25.0828 28.1135L25.1575 25.1593Z",
    fill: "#F39200"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.73837 42.5409C8.25412 41.6493 6.62038 40.5428 5.2002 39.5544V39.8982L9.73837 42.9491V42.5409Z",
    fill: "#936037"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7812 42.2509C28.0834 42.7128 26.3108 43.1317 24.613 43.4863V43.7441L29.7705 42.6161V42.2509H29.7812Z",
    fill: "#B17F4A"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.65552 14.7819C4.65552 14.7819 4.65552 15.7702 4.65552 15.8024C5.13603 15.6305 8.12589 17.0163 9.28979 18.4236C9.28979 18.2732 9.28979 17.4353 9.28979 17.2956C9.28979 17.2956 9.95183 17.1882 10.0052 17.1775C8.35012 16.4899 6.74842 15.5983 5.40298 14.6637L4.65552 14.7926V14.7819Z",
    fill: "url(#paint17_radial_1_18221)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.781 16.7048C28.1366 17.0379 26.2893 17.3709 24.5808 17.6287C24.7837 17.7361 24.9973 17.8436 25.2001 17.951L30.4431 17.0379L29.781 16.7048Z",
    fill: "url(#paint18_radial_1_18221)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2002 19.0252C26.9087 18.5526 28.724 18.1228 30.4431 17.7791C30.4431 17.532 30.4431 17.2849 30.4431 17.0378L25.2002 17.951C25.2002 18.3055 25.2002 18.6707 25.2002 19.0252Z",
    fill: "url(#paint19_radial_1_18221)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.87305 14.5778C10.0268 16.3289 14.3941 15.8347 19.541 15.1901C20.3845 15.0183 21.2494 14.8571 22.125 14.7067C26.172 14.0192 30.8704 13.3531 34.7999 12.9342L29.8026 10.603C26.439 11.1616 23.2462 11.9566 19.872 12.5152C15.2591 13.2779 10.5073 13.8473 5.87305 14.5778Z",
    fill: "url(#paint20_radial_1_18221)"
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1137 11.8169L21.0891 12.2036C22.7229 7.86358 24.4207 5.87619 27.3144 2.14849C25.5525 2.46003 23.8334 2.86825 22.2637 3.59875C21.9647 2.5782 21.5803 1.66507 21.0571 0.913086C19.2952 2.64265 18.5264 4.57633 18.3235 6.41332C18.142 8.0462 18.4623 9.76502 19.1137 11.8061V11.8169Z",
    fill: "url(#paint21_radial_1_18221)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0074 9.12054C21.1425 9.47505 19.466 9.46431 18.8253 8.66935C18.5797 8.36856 18.4516 8.14296 18.2808 7.71326C18.3342 8.97015 18.6331 10.3022 19.1136 11.8062L21.0891 12.1929C21.6764 10.6245 22.2744 9.36762 22.9364 8.21816C22.5947 8.62638 22.221 9.02386 22.0074 9.1098V9.12054Z",
    fill: "url(#paint22_radial_1_18221)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3129 6.6282C18.4838 6.39186 18.7934 6.13404 19.338 6.11255C20.2457 6.09107 22.7336 6.32741 23.2782 7.05791C23.353 7.16533 23.4064 7.27276 23.4384 7.40167C24.0257 6.46706 24.6664 5.58616 25.3925 4.63007C25.0294 4.70527 24.677 4.76972 24.2713 4.78047C22.9792 4.81269 21.1106 4.63007 19.9787 3.98551C19.5943 3.75992 19.4234 3.45912 19.3701 3.10461C18.7614 4.20036 18.4411 5.32834 18.3236 6.42409C18.3236 6.48855 18.3129 6.553 18.3022 6.61746L18.3129 6.6282Z",
    fill: "url(#paint23_radial_1_18221)"
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7933 12.5904L20.4057 11.3657C18.2808 7.25128 17.9284 4.65156 17.0955 0C16.1558 1.52546 15.3016 3.09388 14.8104 4.75899C13.8494 4.29706 12.9204 3.98552 12.0234 3.87809C12.1302 6.35964 13.0592 8.21812 14.2872 9.59318C15.3763 10.8178 16.8713 11.7202 18.804 12.5904H18.7933Z",
    fill: "url(#paint24_radial_1_18221)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.65,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7186 8.6264C18.4089 9.51804 17.2877 10.7642 16.2626 10.7212C15.8782 10.6997 15.6219 10.6568 15.1948 10.4849C16.1558 11.2798 17.3518 11.9459 18.7827 12.5904L20.395 11.3658C19.6262 9.88329 19.0923 8.59417 18.6759 7.33728C18.7506 7.86367 18.7933 8.41154 18.7186 8.6264Z",
    fill: "url(#paint25_radial_1_18221)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4048 9.73283C14.3407 9.44278 14.3514 9.0453 14.7038 8.61559C15.2911 7.91732 17.1277 6.20924 18.0246 6.28444C18.1528 6.28444 18.2702 6.32741 18.3877 6.39186C18.0887 5.32834 17.8538 4.25408 17.6296 3.07239C17.4373 3.40541 17.2558 3.7062 16.9995 4.01774C16.156 5.01681 14.7785 6.29518 13.5505 6.71414C13.1341 6.8538 12.7924 6.7786 12.4934 6.58523C12.8992 7.77767 13.5292 8.76599 14.2553 9.58243C14.298 9.63614 14.3407 9.67911 14.3941 9.73283H14.4048Z",
    fill: "url(#paint26_radial_1_18221)"
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.605 11.9028C18.2702 9.92615 12.0556 4.00695 9.4181 4.85562C7.56012 5.45721 4.50619 10.0121 5.34976 12.2466C5.60603 12.9233 6.27875 13.3853 6.90875 13.6431C10.8703 15.2545 15.3017 14.9107 19.0711 13.9332C19.2526 13.2564 19.4234 12.5688 19.605 11.8921V11.9028Z",
    fill: "url(#paint27_radial_1_18221)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4058 11.731L21.4095 13.7291C24.3033 14.0407 29.8558 13.8473 33.2408 11.7095C33.6038 11.4839 33.9242 11.0757 33.8281 10.4956C33.3796 7.93883 30.347 4.57638 28.1046 4.31856C25.9156 4.07148 21.1639 9.518 20.4164 11.7202L20.4058 11.731Z",
    fill: "url(#paint28_radial_1_18221)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7683 13.2994L17.7042 14.0299C14.4367 14.7818 9.51412 14.9537 6.53494 12.9986C5.22154 12.1284 5.90493 9.7328 6.63104 9.46423C8.91614 8.60482 15.7501 11.8061 17.7683 13.2994Z",
    fill: "url(#paint29_linear_1_18221)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.89478 9.46423C10.6673 12.1714 12.9951 13.6002 16.2306 14.3199C16.7538 14.2447 17.245 14.148 17.7149 14.0406L17.7789 13.3101C16.2413 12.1714 11.8846 10.0336 8.90545 9.46423H8.89478Z",
    fill: "url(#paint30_radial_1_18221)"
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3706 13.2135L22.5094 13.568C25.1683 13.6862 28.4251 13.5143 31.4256 12.3756C32.408 11.9996 33.9456 11.3765 33.5292 10.1626C33.2729 9.43207 32.5681 8.60489 32.2158 8.56192C30.0481 8.3041 24.2393 11.688 22.3813 13.192L22.3706 13.2135Z",
    fill: "url(#paint31_linear_1_18221)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9915 9.13124C31.6925 8.78748 31.4042 8.71228 30.9984 8.6908C28.3716 9.30313 23.9402 11.9243 22.3599 13.2134C24.8265 12.9341 28.9269 12.2144 31.4042 10.9468C31.906 10.6889 32.2905 10.3989 32.3652 10.0336C32.4079 9.79729 32.3011 9.50724 31.9915 9.13124Z",
    fill: "url(#paint32_radial_1_18221)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.6417 9.46431C7.63476 9.08831 9.49274 9.48579 11.4468 10.1733C11.0197 9.67916 10.9236 8.81975 11.4682 7.98182C12.2477 6.78939 13.6251 6.6927 14.6823 7.0687C13.2835 6.00518 11.8419 5.12428 10.678 4.85571C10.1441 4.9524 9.83444 5.03834 9.31121 5.42507C8.00849 6.37043 6.55627 8.5297 6.11847 9.7651C6.03305 10.0122 5.96898 10.2807 5.92627 10.5493C6.07576 10.0122 6.36407 9.57173 6.6417 9.46431Z",
    fill: "url(#paint33_radial_1_18221)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.457 4.57631C27.9872 4.42591 27.5173 4.4474 26.8766 4.60854C26.0438 5.00602 25.0721 5.76874 24.1431 6.68187C24.677 6.29513 25.2002 6.17696 26.236 6.32736C27.4746 6.52073 28.4463 7.39088 28.6599 8.5296C28.7667 9.15268 28.5745 9.44273 28.2221 9.72204C29.8238 8.98079 31.3294 8.46515 32.2264 8.57257C32.472 8.6048 32.8884 9.00228 33.2087 9.49644C32.4186 7.75613 30.5392 5.22087 28.4677 4.56557L28.457 4.57631Z",
    fill: "url(#paint34_radial_1_18221)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9435 9.73284C21.9862 9.4965 22.0716 9.26016 22.1677 9.03457C22.2425 8.87343 22.3279 8.72303 22.4133 8.57263C22.2852 8.73377 22.1571 8.89491 22.0289 9.05605C21.9328 9.18496 21.8367 9.31387 21.7406 9.44279C21.1747 10.2163 20.7369 10.936 20.502 11.4946C20.7796 12.0962 21.7406 12.7837 22.6055 13.0308C23.0754 12.6763 23.7054 12.2466 24.4315 11.7847C24.7411 11.5913 25.0722 11.3979 25.4032 11.1938C24.912 11.3765 24.4422 11.5054 23.951 11.5054C22.8832 11.5054 21.7193 10.9897 21.9435 9.72209V9.73284Z",
    fill: "url(#paint35_radial_1_18221)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6401 10.3236C17.5867 11.0112 16.5723 11.6557 15.9316 11.6665C15.3977 11.6772 14.8104 11.4946 14.2979 11.3549C15.4404 11.8921 16.4762 12.4507 17.2023 12.9126C18.1633 12.7515 18.9535 12.1821 19.2631 11.4624C18.8147 10.9038 18.142 10.1625 17.3411 9.38904C17.5333 9.67909 17.6614 9.99063 17.6401 10.3236Z",
    fill: "url(#paint36_radial_1_18221)"
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8928 13.5464C16.818 13.1704 17.3946 12.687 18.0567 12.2358C18.8469 11.688 19.5409 11.3442 19.872 11.3872C20.7262 11.4731 23.7908 13.3745 23.0006 14.4381C22.424 15.2115 20.566 15.276 19.6584 15.2008C18.7935 15.1363 17.085 14.5777 16.8928 13.5464Z",
    fill: "#C45800"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6402 13.8366C18.0887 14.2233 18.7828 14.4382 19.5303 14.5348C20.2991 14.6315 21.1106 14.5886 21.8047 14.4704C23.0113 14.2555 23.1288 13.6002 22.6269 13.0416C22.0396 12.3971 21.0252 11.7203 20.3098 11.3872C20.0001 11.2476 19.6797 11.2476 19.3808 11.398C18.8362 11.6773 18.1635 12.107 17.6936 12.4723C16.9996 13.0094 16.9889 13.2672 17.6402 13.8366Z",
    fill: "url(#paint37_radial_1_18221)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.189 12.6334C21.6123 12.1392 20.8649 11.6665 20.3096 11.398C20 11.2476 19.6689 11.2583 19.37 11.4087C18.8467 11.6773 18.2274 12.0748 17.7576 12.4185C17.7576 13.6539 22.4559 13.901 22.3064 12.8482C22.2957 12.7623 22.253 12.6871 22.189 12.6334Z",
    fill: "url(#paint38_radial_1_18221)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1_18221",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.715361 22.9247) scale(27.3999 27.5656)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F0000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1_18221",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.18258 2.69635) scale(48.8521 49.1476)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E60E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#730000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1_18221",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.1446 30.8529) scale(16.0171 16.114)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F9F4F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E9D9DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#D0ADB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#AD6F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#822341"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1_18221",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.5974 21.1415) scale(32.6001 32.7973)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F9F4F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E9D9DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#D0ADB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#AD6F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#822341"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1_18221",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-2.76556 42.0145) scale(25.275 25.4278)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FAF6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#ECDED9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#D6B7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#B8816F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#923E22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#822000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1_18221",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.685 41.4881) scale(22.9365 23.0752)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FAF6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#ECDED9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#D6B7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#B8816F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#923E22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#822000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_1_18221",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.34223 12.8589) scale(30.347 30.5306)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F0000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_1_18221",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.4447 -9.77585) scale(39.2312 39.4685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E60E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#730000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_1_18221",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.315 25.0519) scale(59.8292 60.191)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F23559"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C40000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_1_18221",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.2808 26.4054) scale(35.921 36.1383)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A8A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_1_18221",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.56754 37.3951) scale(42.1356 42.3905)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A8A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_1_18221",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.5275 -5.85473) scale(33.4757 33.6782)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA9E67"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_1_18221",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.08334 10.5063) scale(40.3737 40.6179)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B35100"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_1_18221",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.07161 5.12422) scale(36.8179 37.0406)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF80D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78A0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_1_18221",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.3775 13.0845) scale(22.0182 22.1513)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC9C0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCF80D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_1_18221",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.6733 19.5086) scale(6.11853 6.15553)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B85E16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_1_18221",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.7224 13.944) scale(10.913 10.979)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC9C0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCF80D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_1_18221",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.01483 11.8599) scale(9.28991 9.3461)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF385"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_1_18221",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.6524 20.5937) scale(9.77042 9.82951)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F24C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_1_18221",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.489 14.6422) scale(10.4431 10.5063)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_1_18221",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.0834 10.0766) scale(31.1479 31.3363)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B85E16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_1_18221",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.4522 11.8598) scale(24.8051 24.9552)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78A0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDC0D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_1_18221",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.5376 5.76884) scale(7.41057 7.4554)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA5700"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_1_18221",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.0289 1.8907) scale(7.7843 7.83139)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF48F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_1_18221",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.4127 10.6352) scale(13.6038 13.6861)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78A0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDC0D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_1_18221",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.5899 6.9398) scale(7.03684 7.0794)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA5700"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_1_18221",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.1667 1.91218) scale(8.45702 8.50818)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF48F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_1_18221",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.67437 6.7141) scale(11.4255 11.4946)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCDC0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78A0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_1_18221",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.7992 5.44654) scale(11.1906 11.2583)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCDC0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78A0C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1_18221",
    x1: 5.79815,
    y1: 11.9458,
    x2: 17.7683,
    y2: 11.9458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D46D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9D00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_1_18221",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.6583 7.28348) scale(10.5713 10.6352)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA5700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1_18221",
    x1: 22.3706,
    y1: 11.0864,
    x2: 46.8447,
    y2: 11.0864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D46D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9D00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_1_18221",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.4522 13.6646) scale(11.7459 11.8169)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA5700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_1_18221",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.93748 10.9253) scale(10.1335 10.1948)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF48F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_1_18221",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.41 11.5375) scale(11.5003 11.5698)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF48F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_1_18221",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.7945 8.89491) scale(6.12921 6.16628)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA5700"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_1_18221",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.1024 9.41052) scale(5.36039 5.39281)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA5700"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_1_18221",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.2419 9.39986) scale(6.20395 6.24148)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCDC0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78A0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_1_18221",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.4591 9.03459) scale(5.30699 5.3391)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF48F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresent);
export default __webpack_public_path__ + "static/media/present.4c8badf8.svg";
export { ForwardRef as ReactComponent };